import { EDIT_AGENDA_ITEM } from '../actionTypes'

export const editAgendaItem = (data: object) => ({
  type: EDIT_AGENDA_ITEM.name,
  api: {
    url: 'agenda_items/update',
    data,
  },
})
